import { create } from 'zustand'
import type { AnchorPresence, CallStatus, ConnectionStatus, VisibilityStatus } from '@/types'

interface PresenceState extends AnchorPresence {
  connection_status: ConnectionStatus
  setPresence: (presence: Partial<AnchorPresence>) => void
  setVisibility: (visibilityStatus: VisibilityStatus) => void
  setCallStatus: (callStatus: CallStatus) => void
  setConnectionStatus: (connectionStatus: ConnectionStatus) => void
  resetPresence: () => void
}

const defaultPresence: AnchorPresence = {
  online_status: 'offline',
  visibility_status: 'unknown',
  call_status: 'idle',
}

export const usePresenceStore = create<PresenceState>((set) => ({
  ...defaultPresence,
  connection_status: 'disconnected',

  setPresence: (presence) => set((state) => ({ ...state, ...presence })),
  setVisibility: (visibility_status) => set({ visibility_status }),
  setCallStatus: (call_status) => set({ call_status }),
  setConnectionStatus: (connection_status) => set({ connection_status }),
  resetPresence: () => set({ ...defaultPresence, connection_status: 'disconnected' }),
}))
